import type * as React from 'react';
import {useState} from 'react';
import type {AutocompleteOption} from '@/components/Capacity/CapacityDefaultAutoComplete';
import CapacityDefaultAutoComplete from '@/components/Capacity/CapacityDefaultAutoComplete';
import {useAddCapacityDefault} from '@/hooks/capacity/useAddCapacityDefault';
import type {CapacityLabel} from '@/types/CapacityLabel';
import type {Employee} from '@/types/Employee';

type Props = {
    employee : Employee;
    open : boolean;
    setOpen : (open : boolean) => void;
    capacityYearMonth : string;
    capacityLabels : CapacityLabel[];
};

const AddEmployeeCapacityAutoComplete : React.FC<Props> = ({employee, capacityLabels} : Props) => {
    const addCapacityProjectQuery = useAddCapacityDefault();
    const [value, setValue] = useState<AutocompleteOption | undefined>();
    const [textValue, setTextValue] = useState('');

    const doCreateCapacity = () => {
        if (textValue) {
            addCapacityProjectQuery.mutate({
                associateID: employee.id,
                labelText: textValue,
            });
        }
    };

    return <CapacityDefaultAutoComplete
        capacityLabels={capacityLabels}
        value={value}
        setValue={setValue}
        setTextValue={setTextValue}
        selectedCallback={() => {
            doCreateCapacity();
        }}
    />;
};

export default AddEmployeeCapacityAutoComplete;
